import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const OccupancyChart = () => {
  const data = [
    { month: 'Aug', rate: 92 },
    { month: 'Sep', rate: 94 },
    { month: 'Oct', rate: 91 },
    { month: 'Nov', rate: 95 },
    { month: 'Dec', rate: 93 },
    { month: 'Jan', rate: 96 },
  ];

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground font-heading">Occupancy Rate Trend</h3>
        <span className="text-sm text-muted-foreground font-caption">Last 6 months</span>
      </div>
      
      <div className="w-full h-80" aria-label="Occupancy Rate Line Chart">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="month" 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px', fontFamily: 'Inter, sans-serif' }}
            />
            <YAxis 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px', fontFamily: 'Inter, sans-serif' }}
              domain={[85, 100]}
              tickFormatter={(value) => `${value}%`}
            />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: 'var(--color-surface)', 
                border: '1px solid var(--color-border)',
                borderRadius: '10px',
                fontFamily: 'Inter, sans-serif'
              }}
              formatter={(value) => `${value}%`}
            />
            <Line 
              type="monotone" 
              dataKey="rate" 
              stroke="var(--color-success)" 
              strokeWidth={3}
              dot={{ fill: 'var(--color-success)', r: 5 }}
              activeDot={{ r: 7 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default OccupancyChart;